<template>
  <nav class="nav">
    <div class="nav__header">
      <NuxtLink to="/">
        <Button variant="ghost" size="icon">
          <ButtonIcon icon="lucide:arrow-left" />
        </Button>
      </NuxtLink>

      <div style="font-size: 18px; font-weight: 500; color: var(--gray-2)">Paramètres</div>
    </div>

    <div class="nav__content">
      <NavButtonGroup>
        <NavSection :section="generalSection" />
      </NavButtonGroup>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useManagees } from "~/components/team-member/composables/useManagees";
import type { AppRole } from "@asap/shared/utils";
import type { Color } from "@asap/design/styles/colors";

const { isManager } = useManagees();

const generalSection = computed(() => {
  const section = {
    name: "Général",
    icon: "i-ph-gear",
    color: "secondary" as Color,
    items: [
      {
        to: "/settings/account",
        icon: "i-ph-user",
        label: "Mon compte",
        roles: [] as AppRole[],
      },
      {
        to: "/settings/workspace",
        icon: "i-ph-buildings",
        label: "Workspace",
        roles: [] as AppRole[],
      },
      {
        to: "/settings/members",
        icon: "i-ph-users",
        label: "Membres",
        roles: [] as AppRole[],
      },
    ],
  };
  if (isManager.value) {
    section.items.push({
      to: "/settings/managees",
      icon: "i-ph-users-three",
      label: "Managés",
      roles: [] as AppRole[],
    });
  }
  return section;
});
</script>

<style scoped lang="scss">
.nav {
  display: flex;
  align-items: flex-start;
  background: var(--white);
  box-shadow: var(--shadow-0);
  flex-shrink: 0;
  transition: var(--transition-2);
  overflow: hidden;
  position: relative;
}

.nav__header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 204px;
  padding: 12px 16px;
}

.nav__content {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-block: 16px;
  padding-inline: 16px;
  flex: 1;
  width: 204px;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
